import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const SOCIAL_HOVER = { scale: 1.1, y: -2 };

const SOCIAL_LINKS = [
  { Icon: Facebook, href: '#', id: 'facebook' },
  { Icon: Twitter, href: '#', id: 'twitter' },
  { Icon: Instagram, href: '#', id: 'instagram' },
  { Icon: Linkedin, href: '#', id: 'linkedin' },
];

const SocialLinks = () => {
  return (
    <div className="flex space-x-4">
      {SOCIAL_LINKS.map(({ Icon, href, id }) => (
        <motion.a
          key={id}
          whileHover={SOCIAL_HOVER}
          href={href}
          className="w-10 h-10 rounded-lg bg-white/10 hover:bg-gradient-to-br hover:from-blue-500 hover:to-purple-600 flex items-center justify-center transition-all"
        >
          <Icon className="w-5 h-5 text-white" />
        </motion.a>
      ))}
    </div>
  );
};

export default SocialLinks;
